
<v-dialog
    v-model       = "show"
    max-width     = "600"
    class         = "white"
    :scrollable   = "false"
    content-class = "dialog-border"
    persistent
    no-click-animation
>
    <div class="pt-2 pb-1 white" style="position: relative">
        <div class="close-button v-flex">
            <c-toolbar-button
                size     = "26"
                color    = "primary"
                icon     = "mdi-refresh"
                :tooltip = "$t('common.refresh')"
                @click   = "onRefreshConfirmation"
            />
            <c-toolbar-button
                class    = "ml-3"
                size     = "28"
                color    = "red"
                icon     = "mdi-close"
                :tooltip = "$t('common.close')"
                @click   = "onCancel"
            />
        </div>
        <div class="ml-4 mt-1 w-100" >
            <div style="position: relative; width: calc(50% - 16px)">
                <div class="w-100">
                    <input
                        v-model = "search"
                        class   = "lm-border search-field"
                        @input  = "onSearch"
                    />
                </div>
                <div style="position: absolute; right: 10px; top: 10px">
                    <v-icon size="22" color="lightgray">mdi-magnify</v-icon>
                </div>
            </div>
        </div>
        <v-expand-transition>
            <v-card height="165" v-if="showRefresh" class="ma-4 ">
                <v-card-text class="text-center mb-0 pb-0" v-html="$t('msd.customer.responsibles.refresh.info')">
                </v-card-text>
                <v-card-actions class="confirm-actions">
                    <v-btn
                        class  = "dialog-button mr-0"
                        @click = "onCancel"
                        depressed
                    >
                        {{ $t('common.no') }}
                    </v-btn>
                    <v-btn
                        class  = "dialog-button primary pl-3 pr-3"
                        @click = "onRefresh"
                        depressed
                    >
                        {{ $t('common.yes') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-divider class="mt-3 mb-1" />
        <div class="ml-4 mr-1 mb-2">
            <c-card-iterator
                :show-title ="false"
                :items  = "filtered"
                :height = 500
                :item-height = "32"
            >
                <template v-slot:card="{ item }">
                    <c-customer-responsibility-card
                        :area         = "item.area"
                        :responsibles = "customer.responsibles"
                        :selected     = "item.user"
                        @changed      = "onSelected"
                    />
                </template>
            </c-card-iterator>
        </div>
    </div>
</v-dialog>
